export default __webpack_public_path__ + "static/media/9.584b0e28.png";